import { render, staticRenderFns } from "./CreateContentItem.vue?vue&type=template&id=841842a8&scoped=true&"
import script from "./CreateContentItem.vue?vue&type=script&lang=js&"
export * from "./CreateContentItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateContentItem.vue?vue&type=style&index=0&id=841842a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841842a8",
  null
  
)

export default component.exports